var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{key:_vm.strIcone+_vm.key,attrs:{"icon":_vm.strIcone}})}
var staticRenderFns = []

export { render, staticRenderFns }